export default {
  // 폴더 색상
  'dashboard.color_indigo': '인디고',
  'dashboard.color_purple': '보라',
  'dashboard.color_pink': '핑크',
  'dashboard.color_red': '빨강',
  'dashboard.color_orange': '주황',
  'dashboard.color_yellow': '노랑',
  'dashboard.color_green': '초록',
  'dashboard.color_teal': '청록',

  // 사이드바
  'dashboard.all_presentations': '전체 프레젠테이션',
  'dashboard.new_project': '새 프로젝트',
  'dashboard.projects': '프로젝트',
  'dashboard.project_name_placeholder': '프로젝트 이름',
  'dashboard.storage': '저장 공간',

  // 헤더
  'dashboard.pdf_upload': 'PDF 업로드',
  'dashboard.upload': '업로드',
  'dashboard.search_placeholder': '파일 이름 검색...',

  // 정렬 옵션
  'dashboard.sort_date_desc': '최신순',
  'dashboard.sort_date_asc': '오래된순',
  'dashboard.sort_name_asc': '이름 오름차순',
  'dashboard.sort_name_desc': '이름 내림차순',
  'dashboard.sort_size_desc': '크기 큰순',
  'dashboard.sort_size_asc': '크기 작은순',

  // 검색 결과
  'dashboard.search_result_count': '{{count}}개의 파일이 검색되었습니다.',

  // 업로드 영역
  'dashboard.uploading': '업로드 중...',
  'dashboard.click_or_drag': '클릭 또는 드래그',
  'dashboard.select_file': '파일 선택',

  // PDF 카드
  'dashboard.no_image': '이미지 없음',
  'dashboard.auto_play_on_login': '로그인 시 자동 재생',
  'dashboard.speaker_notes': '발표자노트',
  'dashboard.share': '공유',
  'dashboard.folder': '폴더',

  // 삭제 모달
  'dashboard.delete_file_confirm': '파일을 삭제하시겠습니까?',
  'dashboard.delete_file_warning': '삭제된 파일은 복구할 수 없습니다.',
  'dashboard.delete_folder_confirm': '폴더를 삭제하시겠습니까?',
  'dashboard.delete_folder_name': '{{name}} 폴더가 삭제됩니다.',
  'dashboard.delete_folder_warning': '안에 있는 프레젠테이션은 분류 없음으로 이동합니다.',

  // 빈 상태
  'dashboard.no_search_results': '검색 결과가 없습니다.',
  'dashboard.no_presentations': '업로드된 프레젠테이션이 없습니다.',
  'dashboard.no_presentations_hint': '위 업로드 버튼을 눌러 PDF를 추가하세요.',

  // QR 스캔
  'dashboard.qr_scan': 'QR 스캔하기',

  // 알림
  'dashboard.pdf_only': 'PDF 파일만 업로드 가능합니다.',
  'dashboard.upload_failed': 'PDF 업로드에 실패했습니다: {{message}}',
  'dashboard.save_failed': 'PDF 정보 저장에 실패했습니다: {{message}}',
  'dashboard.upload_error': 'PDF 업로드 중 오류가 발생했습니다.',
  'dashboard.enter_file_name': '파일 이름을 입력해주세요.',
  'dashboard.rename_error': '파일 이름 변경 중 오류가 발생했습니다.',
  'dashboard.delete_error': 'PDF 삭제 중 오류가 발생했습니다.',
  'dashboard.file_too_large': '파일 크기가 {{limit}}MB를 초과합니다.',
  'dashboard.storage_exceeded': '저장 공간이 부족합니다. 무료 플랜은 총 {{limit}}MB까지 사용할 수 있습니다.',

  // 폴더 페이지
  'dashboard.folder_move': '폴더 이동',
  'dashboard.current_folder': '현재 폴더: {{name}}',
  'dashboard.no_folder': '폴더 미지정',
  'dashboard.select_folder': '폴더 선택',
  'dashboard.new_folder': '새 폴더',
  'dashboard.folder_name_placeholder': '폴더 이름',
  'dashboard.unassigned': '폴더 미지정',

  // 공유 페이지
  'dashboard.share_settings': '공유 설정',
  'dashboard.share_link': '공유 링크',
  'dashboard.share_link_desc': '링크를 통해 프레젠테이션을 공유합니다',
  'dashboard.password_protection': '비밀번호 보호',
  'dashboard.password_protection_desc': '비밀번호를 설정하여 접근을 제한합니다',
  'dashboard.new_password_placeholder': '새 비밀번호 입력 (변경 시에만)',
  'dashboard.enter_password_placeholder': '비밀번호를 입력하세요',
  'dashboard.existing_password_hint': '현재 비밀번호가 설정되어 있습니다. 변경하려면 새 비밀번호를 입력하세요.',
  'dashboard.expiry': '만료 기간',
  'dashboard.expiry_desc': '공유 링크의 유효 기간을 설정합니다',
  'dashboard.expiry_none': '무제한',
  'dashboard.expiry_1h': '1시간',
  'dashboard.expiry_24h': '24시간',
  'dashboard.expiry_7d': '7일',
  'dashboard.expiry_30d': '30일',
  'dashboard.share_save_error': '저장에 실패했습니다. 다시 시도해주세요.',

  // 발표자 노트 페이지
  'dashboard.speaker_notes_title': '발표자 노트',
  'dashboard.page_select': '페이지 선택',
  'dashboard.page_number': '{{page}}페이지',
  'dashboard.page_notes': '{{page}}페이지 노트',
  'dashboard.char_count': '{{count}} / 500자',
  'dashboard.notes_placeholder': '이 페이지에 대한 발표자 노트를 입력하세요...',
  'dashboard.notes_tip_title': '발표자 노트 활용 팁',
  'dashboard.notes_tip_desc': '각 페이지별로 발표 시 참고할 내용을 메모해두세요. 발표 중 모바일 리모컨에서 확인할 수 있습니다.',
};
